import { Injectable } from '@angular/core';
import { CustomersAPIService } from '../API/CustomersAPI.service';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CustomersService{
  configUrl: string;

    constructor(private customerService: CustomersAPIService) {
  }

  public getRefererClient() {
    return this.customerService.getRefererClient();
  }

  public getAll() : any {
    return this.customerService.getAll();
  }

  getCustomerById() {
    return this.customerService.getCustomerById();
  }

  getDataGPSCitronellaById() {
    if(!environment.production) console.log("/api/Customer/GetGPSDataByClientId/");
    return this.customerService.getDataGPSCitronellaById();
  }
}
